import { TEST_ID_AI_PLAYER_SUMMARY } from "e2e/testId";
import { memo } from "react";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";
import { Stack } from "@/components/atoms/Stack";

/**
 * Props interface for AIPlayerSummaryEmptyStateView component
 */
interface AIPlayerSummaryEmptyStateViewProps {
  isDark: boolean;
  isSmallScreen: boolean;
  onRefresh: () => void;
}

/**
 * AIPlayerSummaryEmptyStateView component - pure UI for empty state
 *
 * Displays a message and a "Generate Summary" button when no AI summary exists.
 * @param props - Component props
 * @param props.isDark - Whether dark theme is active
 * @param props.isSmallScreen - Whether the screen is small (mobile)
 * @param props.onRefresh - Callback to generate the summary
 */
const AIPlayerSummaryEmptyStateView = ({
  isSmallScreen,
  onRefresh,
}: AIPlayerSummaryEmptyStateViewProps) => (
  <Stack
    className={`w-full items-center justify-center gap-3 ${isSmallScreen ? "py-8" : "py-10"}`}
  >
    <Text variant="body" className="text-center text-content-secondary">
      No summary available
    </Text>
    <Button
      testID={TEST_ID_AI_PLAYER_SUMMARY.GENERATE_BUTTON}
      label="Generate Summary"
      tone="primary"
      size="sm"
      onPress={onRefresh}
    />
  </Stack>
);

AIPlayerSummaryEmptyStateView.displayName = "AIPlayerSummaryEmptyStateView";

export default memo(AIPlayerSummaryEmptyStateView);
